import Cookies from 'js-cookie';

export default (pageViews) => ({
  pageViews: pageViews,
  open: false,
  exitEnabled: false,
  init() {
    this.$nextTick(() => {
      this.exitPopUp();
    });

    const observer = new MutationObserver((mutationList) => {
      this.bodyObserver(mutationList);
    });
    observer.observe(document.body, {
      attributes: true,
    });
  },
  exitPopUp() {
    if (this.exitEnabled) {
      if (typeof Cookies.get('exit-popup') === 'undefined') {
        if (typeof Cookies.get('exit-count') === 'undefined') {
          Cookies.set('exit-count', 1);
        } else {
          Cookies.set('exit-count', parseInt(Cookies.get('exit-count')) + 1);
        }
      }

      document.addEventListener('mouseleave', (event) => {
        if (
          Cookies.get('exit-count') > this.pageViews &&
          typeof Cookies.get('exit-popup') === 'undefined'
        ) {
          if (event.clientY <= 0) {
            this.open = true;
            Cookies.set('exit-popup', 1, {
              expires: 30,
            });
          }
        }
      });
    }
  },
  isExitEnabled() {
    this.exitEnabled = document.body.classList.contains('exit-enabled');
  },
  bodyObserver(mutationList) {
    mutationList.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class'
      ) {
        this.isExitEnabled();
        this.exitPopUp();
      }
    });
  },
});
